export const sendWsDebugMessage = (type, data) => {
  try {
    const bc = new BroadcastChannel('ws-network-debugger');
    bc.postMessage({ 
      type, 
      timestamp: Date.now(), 
      data,
      triggerUrl: window.location.pathname + window.location.search
    });
    bc.close();
  } catch (error) {
    console.error('Failed to send ws debug message:', error);
  }
};
